<script>
  import PauseIcon from '$icons/PauseIcon.svelte';
</script>

<div
  class="ml-auto mr-2 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-amber-950 px-2 py-0.5 text-[10px] font-medium text-amber-200 opacity-70 ring-1 ring-inset ring-amber-900 lg:text-[8.5px] xl:text-[10px]"
>
  <span>Paused</span>
  <PauseIcon class="h-2 w-2 text-amber-200" />
</div>
